import API from '../../API';
import Error from '../../components/Error';
import Head from 'next/head';
import Ad from '../../layout/Ad';
import {useSearchParams} from 'next/navigation';
import Video from '../../components/Video';
import {getProfilePictureURL} from '../../util/userUtil';
import Link from 'next/link';
import {formatCount} from '../../util/formatUtil';
import {I18nText} from '../../i18n/I18nText';
import {useI18NStringProvider} from '../../i18n/i18n';

export default function Search({results, error}) {
    const searchParams = useSearchParams();
    const i18n = useI18NStringProvider();

    if (error) {
        return <Error error={error}/>;
    }

    let q = searchParams.get('q');

    return <div className="p-3 max-w-1300px m-auto">
        <Head>
            <title>{`${i18n('search.html_title', {query: q})} - CornHub`}</title>
        </Head>
        <h1 className="text-2xl font-bold mb-3"><I18nText id="search.title" placeholders={{query: q}}/></h1>

        {results.users.length === 0 && results.videos.length === 0 ? <div>
            <I18nText id="search.results.no_results"/>
        </div> : null}

        {results.users.length !== 0 ? <>
            <h2 className="text-xl"><I18nText id="search.results.cornstars"/></h2>
            <div className="flex">
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-3 md:w-2/3">
                    {
                        results.users.map((model) => <Link href={`/model/${model.username}`} key={model.id}>
                            <div
                                className="w-full aspect-square bg-no-repeat bg-contain"
                                style={{
                                    backgroundImage: `url(${getProfilePictureURL(model)})`,
                                    backgroundPosition: '50% 50%'
                                }}/>
                            <h2 className="text-xl font-bold">{model.display_name ?? model.username}</h2>
                            <h3 className="text-slate-400">
                                <I18nText
                                    id={model.video_count !== 1 ? 'model.video_count.plural' : 'model.video_count.single'}
                                    placeholders={{count: formatCount(model.video_count)}}/>
                            </h3>
                        </Link>)
                    }
                </div>
                <div className="m-auto w-1/3">
                    <Ad orientation="square" page="search" position="besides-models" context={q}/>
                </div>
            </div>
        </> : null}


        {results.videos.length !== 0 ? <h2 className="text-xl"><I18nText id="search.results.videos"/></h2> : null}
        <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
            {
                results.videos.map((video) => <Video video={video} key={video.id}/>)
            }
        </div>

        <Ad orientation="horizontal" page="search" position="bottom" context={q}/>
    </div>;
}

Search.getInitialProps = async ({req, res = {}, query}) => {
    const {data, errored, status} = await API.get('/search', {req, params: {query: query.q}});

    if (errored) {
        if (status === 400) {
            res.statusCode = 400;
            return {error: {status: 400, message: '400 - Bad Query'}};
        }

        res.statusCode = 503;
        return {error: {status: 503}};
    }

    return {results: data};
}

